import React from "react";

const DebitOptionsBus = (props) => {
  const options = [
    {
      text: 'J’ai de la difficulté avec mon terminal. Pouvez-vous m’aider?',
      handler: props.actionProvider.DebitBus1,
      id: 1
    },
    {
      text: 'Qu’est-ce qu’un « acquéreur »?',
      handler: props.actionProvider.DebitBus2,
      id: 2
    },
    {
      text: 'J’ouvre une petite entreprise individuelle. Puis-je utiliser Débit INTERAC pour accepter des paiements ou le service est-il réservé aux grandes entreprises?',
      handler: props.actionProvider.DebitBus3,
      id: 3
    },
    {
      text: 'Comment puis-je obtenir un terminal Débit INTERAC?',
      handler: props.actionProvider.DebitBus4,
      id: 4
    },
    {
      text: 'Quels sont les frais associés à Débit INTERAC?',
      handler: props.actionProvider.DebitBus5,
      id: 5
    },
    {
      text: 'J’ai l’intention d’ouvrir une nouvelle entreprise. Combien de temps faut-il habituellement pour établir le contrat et installer le terminal Débit INTERAC?',
      handler: props.actionProvider.DebitBus6,
      id: 6
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container debit-products'>{optionsMarkup}</div>;
};

export default DebitOptionsBus;